// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d43829c8","389":"23abdd00","732":"72d34d7e","977":"02f7c281"}[chunkId] + ".chunk.js";
};